module.exports = __webpack_public_path__ + "img/promo-bg.d8a8436.jpg";